<williams-ui-platform-stack-layout class="d-flex w-px-8 w-py-12" themeColor="base flex-1">
    <div id="dataInsertion" [innerHTML]="innerHTMLValue"></div>
</williams-ui-platform-stack-layout>